import React from 'react'
import StyledFlexContainer from '../../../../components/containers/flex-container.component'
import { StyledContainer, StyledForm } from './trip-search-section.styles'
import { SearchForm } from '../../../../components/trip-search-bar'

export class TripSearchSection extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<StyledContainer>
				<StyledForm>
					<div className="white f-xx-large title-ticket-sale">
						<span>Viação Planalto Transportes - </span>
						{this.props.muvibus ? (
							`Compre agora a economize!`
						) : (
							<p>Passagens de ônibus mais baratas sem sair de casa</p>
						)}
					</div>
					<SearchForm />
				</StyledForm>
			</StyledContainer>
		)
	}
}
